// // src/components/inventory/ProductForm.js
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { dbHelpers } from '../../db/database';
// import apiClient from '../../api/client';
// import './ProductForm.css';

// function ProductForm() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const isEdit = Boolean(id);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     sku: '',
//     category: '',
//     buying_price: '',
//     selling_price: '',
//     description: '',
//     barcode: ''
//   });
//   const [errors, setErrors] = useState({});
  
//   const [hasVariants, setHasVariants] = useState(false);
//   const [variants, setVariants] = useState([]);
  
//   // ⭐ CHANGED: Warehouse is now REQUIRED, not optional
//   const [warehouses, setWarehouses] = useState([]);
//   const [selectedWarehouse, setSelectedWarehouse] = useState('');
//   const [initialQuantity, setInitialQuantity] = useState('0');

//   useEffect(() => {
//     async function loadWarehouses() {
//       try {
//         const wh = await dbHelpers.getWarehouses();
//         setWarehouses(wh);
//         // Auto-select first warehouse if only one exists
//         if (wh.length === 1) {
//           setSelectedWarehouse(wh[0].id);
//         }
//       } catch (error) {
//         console.error('Failed to load warehouses:', error);
//       }
//     }
//     loadWarehouses();
//   }, []);

//   const loadProduct = useCallback(async () => {
//     setLoading(true);
//     try {
//       const product = await dbHelpers.getProductById(id);
//       if (product) {
//         setFormData({
//           name: product.name || '',
//           sku: product.sku || '',
//           category: product.category || '',
//           buying_price: product.buying_price || product.cost_price || '',
//           selling_price: product.selling_price || '',
//           description: product.description || '',
//           barcode: product.barcode || ''
//         });
        
//         if (product.has_variants && product.variants) {
//           setHasVariants(true);
//           setVariants(product.variants);
//         }
//       } else {
//         alert('Product not found');
//         navigate('/inventory');
//       }
//     } catch (error) {
//       alert('Failed to load product');
//     }
//     setLoading(false);
//   }, [id, navigate]);

//   useEffect(() => {
//     if (isEdit) {
//       loadProduct();
//     }
//   }, [isEdit, loadProduct]);

//   function validateForm() {
//     const newErrors = {};
    
//     if (!formData.name.trim()) {
//       newErrors.name = 'Product name is required';
//     }
    
//     if (formData.selling_price !== '' && parseFloat(formData.selling_price) < 0) {
//       newErrors.selling_price = 'Selling price cannot be negative';
//     }
    
//     if (formData.buying_price !== '' && parseFloat(formData.buying_price) < 0) {
//       newErrors.buying_price = 'Buying price cannot be negative';
//     }
    
//     if (hasVariants && variants.length === 0) {
//       newErrors.variants = 'Please add at least one variant or uncheck "Has Variants"';
//     }
    
//     // ⭐ CHANGED: Warehouse is required for new products
//     if (!isEdit && !selectedWarehouse) {
//       newErrors.warehouse = 'Please select a warehouse';
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     if (!validateForm()) return;
    
//     setSaving(true);
    
//     try {
//       const productData = {
//         name: formData.name.trim(),
//         sku: formData.sku.trim().toUpperCase() || '',
//         category: formData.category.trim() || 'Other',
//         cost_price: formData.buying_price ? parseFloat(formData.buying_price) : 0,
//         selling_price: formData.selling_price ? parseFloat(formData.selling_price) : 0,
//         description: formData.description.trim() || '',
//         barcode: formData.barcode.trim() || null,
//         has_variants: hasVariants,
//         is_active: true
//       };

//       if (navigator.onLine) {
//         let savedProduct;
        
//         if (isEdit) {
//           const response = await apiClient.put(`/products/${id}/`, productData);
//           savedProduct = response.data;
          
//           // ⭐ Update variant prices if changed
//           if (hasVariants && variants.length > 0) {
//             for (const variant of variants) {
//               if (variant.id) {
//                 try {
//                   await apiClient.patch(`/variants/${variant.id}/`, {
//                     cost_price: parseFloat(variant.cost_price),
//                     selling_price: parseFloat(variant.selling_price),
//                   });
//                 } catch (variantError) {
//                   console.error('Failed to update variant:', variantError);
//                 }
//               }
//             }
//           }
          
//           alert('✅ Product updated successfully!');
//         } else {
//           const response = await apiClient.post('/products/', productData);
//           savedProduct = response.data;
//           await dbHelpers.saveProducts([savedProduct]);
          
//           // ⭐ Create variants first
//           const createdVariants = [];
//           if (hasVariants && variants.length > 0) {
//             for (const variant of variants) {
//               try {
//                 const variantResponse = await apiClient.post('/variants/', {
//                   product: savedProduct.id,
//                   variant_sku: variant.variant_sku || `${savedProduct.sku}-${variant.color || 'VAR'}`,
//                   color: variant.color || null,
//                   size: variant.size || null,
//                   material: variant.material || null,
//                   cost_price: parseFloat(variant.cost_price || savedProduct.cost_price),
//                   selling_price: parseFloat(variant.selling_price || savedProduct.selling_price),
//                   barcode: variant.barcode || null,
//                   is_active: true
//                 });
//                 createdVariants.push(variantResponse.data);
//               } catch (variantError) {
//                 console.error('Failed to save variant:', variantError);
//               }
//             }
//           }
          
//           // ⭐ Auto-create stock entries
//           const qty = parseInt(initialQuantity) || 0;
          
//           if (hasVariants && createdVariants.length > 0) {
//             // Create stock for each variant
//             for (const variant of createdVariants) {
//               try {
//                 await apiClient.post('/stocks/', {
//                   product: savedProduct.id,
//                   variant: variant.id,
//                   warehouse: selectedWarehouse,
//                   quantity: qty,
//                   reorder_level: 10
//                 });
//               } catch (stockError) {
//                 console.error('Failed to create stock for variant:', stockError);
//               }
//             }
//           } else {
//             // Create stock for non-variant product
//             try {
//               await apiClient.post('/stocks/', {
//                 product: savedProduct.id,
//                 warehouse: selectedWarehouse,
//                 quantity: qty,
//                 reorder_level: 10
//               });
//             } catch (stockError) {
//               console.error('Failed to create stock:', stockError);
//             }
//           }
          
//           alert(`✅ Product created!\n${savedProduct.sku ? `SKU: ${savedProduct.sku}` : ''}`);
//         }
//       } else {
//         if (isEdit) {
//           await dbHelpers.updateProduct(id, productData);
//         } else {
//           await dbHelpers.addProduct(productData);
//         }
//         alert('✅ Product saved offline. Will sync when online.');
//       }
      
//       navigate('/inventory');
//     } catch (error) {
//       console.error('Save error:', error);
//       const errorMessage = error.response?.data?.message || 
//                           error.response?.data?.error || 
//                           error.message || 
//                           'Unknown error';
//       alert(`❌ Failed: ${errorMessage}`);
//     } finally {
//       setSaving(false);
//     }
//   }

//   function handleChange(field, value) {
//     setFormData({
//       ...formData,
//       [field]: value
//     });
    
//     if (errors[field]) {
//       setErrors({
//         ...errors,
//         [field]: null
//       });
//     }
//   }

//   const addVariant = () => {
//     setVariants([...variants, {
//       variant_sku: '',
//       color: '',
//       size: '',
//       material: '',
//       cost_price: formData.buying_price || '',
//       selling_price: formData.selling_price || '',
//       barcode: ''
//     }]);
    
//     if (errors.variants) {
//       setErrors({ ...errors, variants: null });
//     }
//   };

//   const removeVariant = (index) => {
//     setVariants(variants.filter((_, i) => i !== index));
//   };

//   const updateVariant = (index, field, value) => {
//     const updated = [...variants];
//     updated[index][field] = value;
//     setVariants(updated);
//   };

//   if (loading) {
//     return <div className="loading-screen">Loading product...</div>;
//   }

//   return (
//     <div className="product-form-container fade-in">
//       <div className="breadcrumb">
//         <button onClick={() => navigate('/inventory')} className="btn-primary">
//           ← Back to Inventory
//         </button>
//       </div>

//       <div className="form-card">
//         <h1>📦 {isEdit ? 'Edit Product' : 'Add New Product'}</h1>
//         <p className="subtitle">Fill in the product details below</p>

//         <form onSubmit={handleSubmit}>
//           <div className="form-section">
//             <h3>📋 Basic Information</h3>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Product Name *</label>
//                 <input
//                   type="text"
//                   value={formData.name}
//                   onChange={(e) => handleChange('name', e.target.value)}
//                   className={`form-input ${errors.name ? 'error' : ''}`}
//                   placeholder="e.g., Argan Oil"
//                 />
//                 {errors.name && <span className="error-text">{errors.name}</span>}
//               </div>

//               <div className="form-group">
//                 <label>SKU (Optional)</label>
//                 <input
//                   type="text"
//                   value={formData.sku}
//                   onChange={(e) => handleChange('sku', e.target.value.toUpperCase())}
//                   className={`form-input ${errors.sku ? 'error' : ''}`}
//                   placeholder={isEdit ? "SKU" : "Leave blank to auto-generate"}
//                   disabled={isEdit}
//                 />
//                 {errors.sku && <span className="error-text">{errors.sku}</span>}
//                 {isEdit && <span className="help-text">SKU cannot be changed</span>}
//                 {!isEdit && (
//                   <span className="help-text" style={{color: '#666', fontSize: '0.85em'}}>
//                     💡 Auto-generates from category and name
//                   </span>
//                 )}
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>Category</label>
//                 <select
//                   value={formData.category}
//                   onChange={(e) => handleChange('category', e.target.value)}
//                   className="form-input"
//                 >
//                   <option value="">Select category</option>
//                   <option value="Cosmetics">Cosmetics</option>
//                   <option value="Textiles">Textiles</option>
//                   <option value="Spices">Spices</option>
//                   <option value="Crafts">Crafts</option>
//                   <option value="Other">Other</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>Barcode (Optional)</label>
//                 <input
//                   type="text"
//                   value={formData.barcode}
//                   onChange={(e) => handleChange('barcode', e.target.value)}
//                   className="form-input"
//                   placeholder="e.g., 1234567890123"
//                 />
//                 <span className="help-text">For barcode scanning</span>
//               </div>
//             </div>
//           </div>

//           <div className="form-section">
//             <h3>💰 Pricing</h3>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Buying Price (TSh)</label>
//                 <input
//                   type="number"
//                   value={formData.buying_price}
//                   onChange={(e) => handleChange('buying_price', e.target.value)}
//                   className={`form-input ${errors.buying_price ? 'error' : ''}`}
//                   step="0.01"
//                   min="0"
//                   placeholder="0.00"
//                 />
//                 {errors.buying_price && <span className="error-text">{errors.buying_price}</span>}
//                 <span className="help-text">Cost price from supplier</span>
//               </div>

//               <div className="form-group">
//                 <label>Selling Price (TSh)</label>
//                 <input
//                   type="number"
//                   value={formData.selling_price}
//                   onChange={(e) => handleChange('selling_price', e.target.value)}
//                   className={`form-input ${errors.selling_price ? 'error' : ''}`}
//                   step="0.01"
//                   min="0"
//                   placeholder="0.00"
//                 />
//                 {errors.selling_price && <span className="error-text">{errors.selling_price}</span>}
//                 <span className="help-text">Price to customers</span>
//               </div>
//             </div>

//             {formData.buying_price > 0 && formData.selling_price > 0 && (
//               <div className="profit-margin">
//                 <span>Profit Margin: </span>
//                 <span className="margin-value">
//                   TSh {(parseFloat(formData.selling_price) - parseFloat(formData.buying_price)).toFixed(2)}
//                   {' '}
//                   ({(((parseFloat(formData.selling_price) - parseFloat(formData.buying_price)) / parseFloat(formData.buying_price)) * 100).toFixed(1)}%)
//                 </span>
//               </div>
//             )}
//           </div>

//           {/* Variants Section */}
//           {(!isEdit || (isEdit && hasVariants)) && (
//             <div className="form-section">
//               <h3>🎨 Product Variants (Optional)</h3>
//               <p className="section-description">
//                 Does this product come in different colors, sizes, or materials?
//               </p>
              
//               <label className="checkbox-label">
//                 <input
//                   type="checkbox"
//                   checked={hasVariants}
//                   onChange={(e) => {
//                     setHasVariants(e.target.checked);
//                     if (!e.target.checked) {
//                       setVariants([]);
//                       if (errors.variants) {
//                         setErrors({ ...errors, variants: null });
//                       }
//                     }
//                   }}
//                   disabled={isEdit}
//                 />
//                 <span>This product has variants (colors, sizes, etc.)</span>
//                 {isEdit && <span className="help-text"> (Cannot change after creation)</span>}
//               </label>

//               {hasVariants && (
//                 <div className="variants-container">
//                   {variants.map((variant, index) => (
//                     <div key={index} className="variant-card">
//                       <div className="variant-header">
//                         <h4>Variant {index + 1}</h4>
//                         {!isEdit && (
//                           <button
//                             type="button"
//                             onClick={() => removeVariant(index)}
//                             className="btn-remove"
//                           >
//                             ✕
//                           </button>
//                         )}
//                       </div>
                      
//                       <div className="variant-fields">
//                         <input
//                           type="text"
//                           placeholder="Color (e.g., Red, Blue)"
//                           value={variant.color || ''}
//                           onChange={(e) => updateVariant(index, 'color', e.target.value)}
//                           className="form-input"
//                           disabled={isEdit}
//                         />
//                         <input
//                           type="text"
//                           placeholder="Size (e.g., S, M, L, XL)"
//                           value={variant.size || ''}
//                           onChange={(e) => updateVariant(index, 'size', e.target.value)}
//                           className="form-input"
//                           disabled={isEdit}
//                         />
//                         <input
//                           type="text"
//                           placeholder="Material (optional)"
//                           value={variant.material || ''}
//                           onChange={(e) => updateVariant(index, 'material', e.target.value)}
//                           className="form-input"
//                           disabled={isEdit}
//                         />
//                         <input
//                           type="number"
//                           placeholder="Buying Price"
//                           value={variant.cost_price || ''}
//                           onChange={(e) => updateVariant(index, 'cost_price', e.target.value)}
//                           className="form-input"
//                           step="0.01"
//                         />
//                         <input
//                           type="number"
//                           placeholder="Selling Price"
//                           value={variant.selling_price || ''}
//                           onChange={(e) => updateVariant(index, 'selling_price', e.target.value)}
//                           className="form-input"
//                           step="0.01"
//                         />
//                         <input
//                           type="text"
//                           placeholder="Barcode (optional)"
//                           value={variant.barcode || ''}
//                           onChange={(e) => updateVariant(index, 'barcode', e.target.value)}
//                           className="form-input"
//                           disabled={isEdit}
//                         />
//                       </div>
//                     </div>
//                   ))}
                  
//                   {!isEdit && (
//                     <button
//                       type="button"
//                       onClick={addVariant}
//                       className="btn-add-variant"
//                     >
//                       ➕ Add Variant
//                     </button>
//                   )}
                  
//                   {errors.variants && (
//                     <span className="error-text">{errors.variants}</span>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ⭐ CHANGED: Warehouse + Stock (REQUIRED for new products) */}
//           {!isEdit && (
//             <div className="form-section">
//               <h3>📦 Warehouse & Stock *</h3>
//               <p className="section-description">
//                 {warehouses.length > 0 
//                   ? "Select where this product will be stored. Stock will be set to 0 if quantity is not specified."
//                   : "⚠️ No warehouses available. Create a warehouse first."}
//               </p>
              
//               {warehouses.length > 0 ? (
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Warehouse *</label>
//                     <select
//                       value={selectedWarehouse}
//                       onChange={(e) => {
//                         setSelectedWarehouse(e.target.value);
//                         if (errors.warehouse) {
//                           setErrors({ ...errors, warehouse: null });
//                         }
//                       }}
//                       className={`form-input ${errors.warehouse ? 'error' : ''}`}
//                       required
//                     >
//                       <option value="">Select warehouse</option>
//                       {warehouses.map(wh => (
//                         <option key={wh.id} value={wh.id}>{wh.name}</option>
//                       ))}
//                     </select>
//                     {errors.warehouse && <span className="error-text">{errors.warehouse}</span>}
//                     <span className="help-text">Required to track inventory</span>
//                   </div>
//                   <div className="form-group">
//                     <label>Initial Quantity</label>
//                     <input
//                       type="number"
//                       value={initialQuantity}
//                       onChange={(e) => setInitialQuantity(e.target.value)}
//                       className="form-input"
//                       min="0"
//                       placeholder="0"
//                     />
//                     <span className="help-text">Leave as 0 if none in stock yet</span>
//                   </div>
//                 </div>
//               ) : (
//                 <button
//                   type="button"
//                   onClick={() => navigate('/warehouses')}
//                   className="btn btn-primary"
//                   style={{marginTop: '12px'}}
//                 >
//                   ➕ Create Warehouse First
//                 </button>
//               )}
//             </div>
//           )}

//           <div className="form-section">
//             <h3>📝 Description (Optional)</h3>
//             <div className="form-group">
//               <textarea
//                 value={formData.description}
//                 onChange={(e) => handleChange('description', e.target.value)}
//                 className="form-input"
//                 rows="4"
//                 placeholder="Add product description, notes, or specifications..."
//               />
//             </div>
//           </div>

//           <div className="form-actions">
//             <button
//               type="button"
//               onClick={() => navigate('/inventory')}
//               className="btn btn-secondary"
//               disabled={saving}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="btn btn-primary"
//               disabled={saving || (!isEdit && warehouses.length === 0)}
//             >
//               {saving
//                 ? (isEdit ? 'Updating...' : 'Creating...')
//                 : (isEdit ? '✅ Update Product' : '✅ Create Product')}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default ProductForm;


// src/components/inventory/ProductForm.js
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dbHelpers } from '../../db/database';
import apiClient from '../../api/client';
import './ProductForm.css';

function ProductForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    sku: '',
    category: '',
    buying_price: '',
    selling_price: '',
    description: '',
    barcode: ''
  });
  const [errors, setErrors] = useState({});
  
  const [hasVariants, setHasVariants] = useState(false);
  const [variants, setVariants] = useState([]);
  
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState('');
  const [initialQuantity, setInitialQuantity] = useState('0');

  useEffect(() => {
    async function loadWarehouses() {
      try {
        const wh = await dbHelpers.getWarehouses();
        setWarehouses(wh);
        if (wh.length === 1) {
          setSelectedWarehouse(wh[0].id);
        }
      } catch (error) {
        console.error('Failed to load warehouses:', error);
      }
    }
    loadWarehouses();
  }, []);

  const loadProduct = useCallback(async () => {
    setLoading(true);
    try {
      const product = await dbHelpers.getProductById(id);
      if (product) {
        setFormData({
          name: product.name || '',
          sku: product.sku || '',
          category: product.category || '',
          buying_price: product.buying_price || product.cost_price || '',
          selling_price: product.selling_price || '',
          description: product.description || '',
          barcode: product.barcode || ''
        });
        
        // ⭐ Load variants
        if (product.has_variants) {
          setHasVariants(true);
          if (product.variants && product.variants.length > 0) {
            setVariants(product.variants);
          }
        }
      } else {
        alert('Product not found');
        navigate('/inventory');
      }
    } catch (error) {
      alert('Failed to load product');
    }
    setLoading(false);
  }, [id, navigate]);

  useEffect(() => {
    if (isEdit) {
      loadProduct();
    }
  }, [isEdit, loadProduct]);

  function validateForm() {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Product name is required';
    }
    
    if (formData.selling_price !== '' && parseFloat(formData.selling_price) < 0) {
      newErrors.selling_price = 'Selling price cannot be negative';
    }
    
    if (formData.buying_price !== '' && parseFloat(formData.buying_price) < 0) {
      newErrors.buying_price = 'Buying price cannot be negative';
    }
    
    if (hasVariants && variants.length === 0) {
      newErrors.variants = 'Please add at least one variant or uncheck "Has Variants"';
    }
    
    if (!isEdit && !selectedWarehouse) {
      newErrors.warehouse = 'Please select a warehouse';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) return;
    
    setSaving(true);
    
    try {
      const productData = {
        name: formData.name.trim(),
        sku: formData.sku.trim().toUpperCase() || '',
        category: formData.category.trim() || 'Other',
        cost_price: formData.buying_price ? parseFloat(formData.buying_price) : 0,
        selling_price: formData.selling_price ? parseFloat(formData.selling_price) : 0,
        description: formData.description.trim() || '',
        barcode: formData.barcode.trim() || null,
        has_variants: hasVariants,
        is_active: true
      };

      if (navigator.onLine) {
        let savedProduct;
        
        if (isEdit) {
          const response = await apiClient.put(`/products/${id}/`, productData);
          savedProduct = response.data;
          
          // ⭐ Update existing variants AND add new ones
          for (const variant of variants) {
            if (variant.id) {
              // Update existing variant
              try {
                await apiClient.patch(`/variants/${variant.id}/`, {
                  cost_price: parseFloat(variant.cost_price),
                  selling_price: parseFloat(variant.selling_price),
                });
              } catch (variantError) {
                console.error('Failed to update variant:', variantError);
              }
            } else {
              // ⭐ NEW: Add new variant
              try {
                await apiClient.post('/variants/', {
                  product: savedProduct.id,
                  variant_sku: variant.variant_sku || `${savedProduct.sku}-${variant.color || 'VAR'}`,
                  color: variant.color || null,
                  size: variant.size || null,
                  material: variant.material || null,
                  cost_price: parseFloat(variant.cost_price || savedProduct.cost_price),
                  selling_price: parseFloat(variant.selling_price || savedProduct.selling_price),
                  barcode: variant.barcode || null,
                  is_active: true
                });
              } catch (variantError) {
                console.error('Failed to create variant:', variantError);
              }
            }
          }
          
          alert('✅ Product updated successfully!');
        } else {
          const response = await apiClient.post('/products/', productData);
          savedProduct = response.data;
          await dbHelpers.saveProducts([savedProduct]);
          
          const createdVariants = [];
          if (hasVariants && variants.length > 0) {
            for (const variant of variants) {
              try {
                const variantResponse = await apiClient.post('/variants/', {
                  product: savedProduct.id,
                  variant_sku: variant.variant_sku || `${savedProduct.sku}-${variant.color || 'VAR'}`,
                  color: variant.color || null,
                  size: variant.size || null,
                  material: variant.material || null,
                  cost_price: parseFloat(variant.cost_price || savedProduct.cost_price),
                  selling_price: parseFloat(variant.selling_price || savedProduct.selling_price),
                  barcode: variant.barcode || null,
                  is_active: true
                });
                createdVariants.push(variantResponse.data);
              } catch (variantError) {
                console.error('Failed to save variant:', variantError);
              }
            }
          }
          
          // Auto-create stock entries
          const qty = parseInt(initialQuantity) || 0;
          
          if (hasVariants && createdVariants.length > 0) {
            for (const variant of createdVariants) {
              try {
                await apiClient.post('/stocks/', {
                  product: savedProduct.id,
                  variant: variant.id,
                  warehouse: selectedWarehouse,
                  quantity: qty,
                  reorder_level: 10
                });
              } catch (stockError) {
                console.error('Failed to create stock for variant:', stockError);
              }
            }
          } else {
            try {
              await apiClient.post('/stocks/', {
                product: savedProduct.id,
                warehouse: selectedWarehouse,
                quantity: qty,
                reorder_level: 10
              });
            } catch (stockError) {
              console.error('Failed to create stock:', stockError);
            }
          }
          
          alert(`✅ Product created!\n${savedProduct.sku ? `SKU: ${savedProduct.sku}` : ''}`);
        }
      } else {
        if (isEdit) {
          await dbHelpers.updateProduct(id, productData);
        } else {
          await dbHelpers.addProduct(productData);
        }
        alert('✅ Product saved offline. Will sync when online.');
      }
      
      navigate('/inventory');
    } catch (error) {
      console.error('Save error:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Unknown error';
      alert(`❌ Failed: ${errorMessage}`);
    } finally {
      setSaving(false);
    }
  }

  function handleChange(field, value) {
    setFormData({
      ...formData,
      [field]: value
    });
    
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: null
      });
    }
  }

  const addVariant = () => {
    setVariants([...variants, {
      variant_sku: '',
      color: '',
      size: '',
      material: '',
      cost_price: formData.buying_price || '',
      selling_price: formData.selling_price || '',
      barcode: ''
    }]);
    
    if (errors.variants) {
      setErrors({ ...errors, variants: null });
    }
  };

  const removeVariant = (index) => {
    setVariants(variants.filter((_, i) => i !== index));
  };

  const updateVariant = (index, field, value) => {
    const updated = [...variants];
    updated[index][field] = value;
    setVariants(updated);
  };

  if (loading) {
    return <div className="loading-screen">Loading product...</div>;
  }

  return (
    <div className="product-form-container fade-in">
      <div className="breadcrumb">
        <button onClick={() => navigate('/inventory')} className="btn-primary">
          ← Back to Inventory
        </button>
      </div>

      <div className="form-card">
        <h1>📦 {isEdit ? 'Edit Product' : 'Add New Product'}</h1>
        <p className="subtitle">Fill in the product details below</p>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>📋 Basic Information</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Product Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  className={`form-input ${errors.name ? 'error' : ''}`}
                  placeholder="e.g., Argan Oil"
                />
                {errors.name && <span className="error-text">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label>SKU (Optional)</label>
                <input
                  type="text"
                  value={formData.sku}
                  onChange={(e) => handleChange('sku', e.target.value.toUpperCase())}
                  className={`form-input ${errors.sku ? 'error' : ''}`}
                  placeholder={isEdit ? "SKU" : "Leave blank to auto-generate"}
                  disabled={isEdit}
                />
                {errors.sku && <span className="error-text">{errors.sku}</span>}
                {isEdit && <span className="help-text">SKU cannot be changed</span>}
                {!isEdit && (
                  <span className="help-text" style={{color: '#666', fontSize: '0.85em'}}>
                    💡 Auto-generates from category and name
                  </span>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Category</label>
                <select
                  value={formData.category}
                  onChange={(e) => handleChange('category', e.target.value)}
                  className="form-input"
                >
                  <option value="">Select category</option>
                  <option value="Cosmetics">Cosmetics</option>
                  <option value="Textiles">Textiles</option>
                  <option value="Spices">Spices</option>
                  <option value="Crafts">Crafts</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Barcode (Optional)</label>
                <input
                  type="text"
                  value={formData.barcode}
                  onChange={(e) => handleChange('barcode', e.target.value)}
                  className="form-input"
                  placeholder="e.g., 1234567890123"
                />
                <span className="help-text">For barcode scanning</span>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>💰 Pricing</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Buying Price (TSh)</label>
                <input
                  type="number"
                  value={formData.buying_price}
                  onChange={(e) => handleChange('buying_price', e.target.value)}
                  className={`form-input ${errors.buying_price ? 'error' : ''}`}
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
                {errors.buying_price && <span className="error-text">{errors.buying_price}</span>}
                <span className="help-text">Cost price from supplier</span>
              </div>

              <div className="form-group">
                <label>Selling Price (TSh)</label>
                <input
                  type="number"
                  value={formData.selling_price}
                  onChange={(e) => handleChange('selling_price', e.target.value)}
                  className={`form-input ${errors.selling_price ? 'error' : ''}`}
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
                {errors.selling_price && <span className="error-text">{errors.selling_price}</span>}
                <span className="help-text">Price to customers</span>
              </div>
            </div>

            {formData.buying_price > 0 && formData.selling_price > 0 && (
              <div className="profit-margin">
                <span>Profit Margin: </span>
                <span className="margin-value">
                  TSh {(parseFloat(formData.selling_price) - parseFloat(formData.buying_price)).toFixed(2)}
                  {' '}
                  ({(((parseFloat(formData.selling_price) - parseFloat(formData.buying_price)) / parseFloat(formData.buying_price)) * 100).toFixed(1)}%)
                </span>
              </div>
            )}
          </div>

          {/* ⭐ FIXED: Show variants section in both create and edit modes */}
          <div className="form-section">
            <h3>🎨 Product Variants (Optional)</h3>
            <p className="section-description">
              Does this product come in different colors, sizes, or materials?
            </p>
            
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={hasVariants}
                onChange={(e) => {
                  if (isEdit) return; // Can't toggle in edit mode
                  setHasVariants(e.target.checked);
                  if (!e.target.checked) {
                    setVariants([]);
                    if (errors.variants) {
                      setErrors({ ...errors, variants: null });
                    }
                  }
                }}
                disabled={isEdit}
              />
              <span>This product has variants (colors, sizes, etc.)</span>
              {isEdit && <span className="help-text"> (Cannot toggle after creation)</span>}
            </label>

            {/* ⭐ FIXED: Show variants if checkbox is checked */}
            {hasVariants && (
              <div className="variants-container">
                {variants.map((variant, index) => (
                  <div key={index} className="variant-card">
                    <div className="variant-header">
                      <h4>Variant {index + 1}</h4>
                      {/* ⭐ FIXED: Allow removing only NEW variants in edit mode */}
                      {(!isEdit || !variant.id) && (
                        <button
                          type="button"
                          onClick={() => removeVariant(index)}
                          className="btn-remove"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                    
                    <div className="variant-fields">
                      <input
                        type="text"
                        placeholder="Color (e.g., Red, Blue)"
                        value={variant.color || ''}
                        onChange={(e) => updateVariant(index, 'color', e.target.value)}
                        className="form-input"
                        disabled={isEdit && variant.id} // Lock existing variants
                      />
                      <input
                        type="text"
                        placeholder="Size (e.g., S, M, L, XL)"
                        value={variant.size || ''}
                        onChange={(e) => updateVariant(index, 'size', e.target.value)}
                        className="form-input"
                        disabled={isEdit && variant.id}
                      />
                      <input
                        type="text"
                        placeholder="Material (optional)"
                        value={variant.material || ''}
                        onChange={(e) => updateVariant(index, 'material', e.target.value)}
                        className="form-input"
                        disabled={isEdit && variant.id}
                      />
                      {/* ⭐ FIXED: Always allow price editing */}
                      <input
                        type="number"
                        placeholder="Buying Price"
                        value={variant.cost_price || ''}
                        onChange={(e) => updateVariant(index, 'cost_price', e.target.value)}
                        className="form-input"
                        step="0.01"
                      />
                      <input
                        type="number"
                        placeholder="Selling Price"
                        value={variant.selling_price || ''}
                        onChange={(e) => updateVariant(index, 'selling_price', e.target.value)}
                        className="form-input"
                        step="0.01"
                      />
                      <input
                        type="text"
                        placeholder="Barcode (optional)"
                        value={variant.barcode || ''}
                        onChange={(e) => updateVariant(index, 'barcode', e.target.value)}
                        className="form-input"
                        disabled={isEdit && variant.id}
                      />
                    </div>
                  </div>
                ))}
                
                {/* ⭐ FIXED: Always allow adding new variants */}
                <button
                  type="button"
                  onClick={addVariant}
                  className="btn-add-variant"
                >
                  ➕ Add Variant
                </button>
                
                {errors.variants && (
                  <span className="error-text">{errors.variants}</span>
                )}
              </div>
            )}
          </div>

          {!isEdit && (
            <div className="form-section">
              <h3>📦 Warehouse & Stock *</h3>
              <p className="section-description">
                {warehouses.length > 0 
                  ? "Select where this product will be stored. Stock will be set to 0 if quantity is not specified."
                  : "⚠️ No warehouses available. Create a warehouse first."}
              </p>
              
              {warehouses.length > 0 ? (
                <div className="form-row">
                  <div className="form-group">
                    <label>Warehouse *</label>
                    <select
                      value={selectedWarehouse}
                      onChange={(e) => {
                        setSelectedWarehouse(e.target.value);
                        if (errors.warehouse) {
                          setErrors({ ...errors, warehouse: null });
                        }
                      }}
                      className={`form-input ${errors.warehouse ? 'error' : ''}`}
                      required
                    >
                      <option value="">Select warehouse</option>
                      {warehouses.map(wh => (
                        <option key={wh.id} value={wh.id}>{wh.name}</option>
                      ))}
                    </select>
                    {errors.warehouse && <span className="error-text">{errors.warehouse}</span>}
                    <span className="help-text">Required to track inventory</span>
                  </div>
                  <div className="form-group">
                    <label>Initial Quantity</label>
                    <input
                      type="number"
                      value={initialQuantity}
                      onChange={(e) => setInitialQuantity(e.target.value)}
                      className="form-input"
                      min="0"
                      placeholder="0"
                    />
                    <span className="help-text">Leave as 0 if none in stock yet</span>
                  </div>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => navigate('/warehouses')}
                  className="btn btn-primary"
                  style={{marginTop: '12px'}}
                >
                  ➕ Create Warehouse First
                </button>
              )}
            </div>
          )}

          <div className="form-section">
            <h3>📝 Description (Optional)</h3>
            <div className="form-group">
              <textarea
                value={formData.description}
                onChange={(e) => handleChange('description', e.target.value)}
                className="form-input"
                rows="4"
                placeholder="Add product description, notes, or specifications..."
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={() => navigate('/inventory')}
              className="btn btn-secondary"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving || (!isEdit && warehouses.length === 0)}
            >
              {saving
                ? (isEdit ? 'Updating...' : 'Creating...')
                : (isEdit ? '✅ Update Product' : '✅ Create Product')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductForm;